import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';

@Injectable({
  providedIn: 'root'
})
export class MatchingVccPaymentGridService implements GridGetService<any> {
  public readonly baseUrl = 'dbov2/connex-pay-accounting-daily-detail/payment-details';
  private readonly http = inject(HttpClient);

  private readonly propertyNameMap: { [key: string]: string } = {
    'connexPayAccountingDailyDetailAmount': 'amount',
    'adxTripReference': 'orderNumber', 
    'agentName': 'name'
  };

  public mapSortProperty(sortProperty?: string): string {
    if (!sortProperty) return '';
    return this.propertyNameMap[sortProperty] || sortProperty;
  }

  public getCurrentFilters(): Record<string, any> {
    return {};
  }

  getItems({filters, page, sort} : GridServiceParams): Observable<GridServiceResponse<any>>  {
    const apiPropertyName = this.mapSortProperty(sort?.active);

    const params:Record<string, string | number | boolean> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: apiPropertyName,
      orderKey: sort?.direction || '',

      ...filters,
    };
    
    removeEmptyParams(params);
    
    return this.http.get<GridServiceResponse<any>>(`${this.baseUrl}`, { params: {...params} })
    .pipe(catchError((error:HttpErrorResponse)=>{
        throw new Error(error?.message || 'Server error');
    }));
  }
}